import { GenericEntityResource } from '/@/modules/core/app/resources/GenericEntityResource';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import Container from '@/modules/core/ioc/Container';

export abstract class BaseResourceService extends BaseService {
  resource;

  constructor() {
    super();

    this.resource = Container.resolve(GenericEntityResource, this.getRoute(), this.getModel());
  }

  abstract getRoute(): string;

  abstract getModel(): typeof BaseModel;
}
